module.exports = (value) => {
    value = value.replace(/[^0-9\*]/, '');

    if (value.indexOf('*') < 0) {
        if (value.length <= 9) {
            return value.replace(/^(.{4,5})(.{4})/, '$1-$2');
        } else {
            return value.replace(/^(.{2})(.{4,5})(.{4})/, '$1 $2-$3');
        }
    }

    return value;
};


// WEBPACK FOOTER //
// ./resources/assets/javascript/templates/maskPhone.js